import branchManagementFinalResidualCountCommitComponent from './final_residual_count_commit.component';
import branchManagementFinalResidualCountCommitPrintModule from './print'

let branchManagementFinalResidualCountCommitModule = angular.module('branchManagementFinalResidualCountCommit', [
  branchManagementFinalResidualCountCommitPrintModule
])
  .component('branchManagementFinalResidualCountCommit', branchManagementFinalResidualCountCommitComponent)
  .name;

export default branchManagementFinalResidualCountCommitModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/final_residual_count_commit/index.js